/**
 * CONSTANTS
 */
const LS_KEY = 'landingFormSubmitTime'

// Import libphonenumber utils
const {
  parsePhoneNumber,
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  validatePhoneNumberLength
} = libphonenumber;

// Countries data
const COUNTRIES_OBJ = {
  af: {
    name: 'Afghanistan',
    code: 'af',
    phoneCode: '93'
  },
  al: {
    name: 'Albania',
    code: 'al',
    phoneCode: '355'
  },
  dz: {
    name: 'Algeria',
    code: 'dz',
    phoneCode: '213'
  },
  ad: {
    name: 'Andorra',
    code: 'ad',
    phoneCode: '376'
  },
  ao: {
    name: 'Angola',
    code: 'ao',
    phoneCode: '244'
  },
  ag: {
    name: 'Antigua and Barbuda',
    code: 'ag',
    phoneCode: '1268'
  },
  ar: {
    name: 'Argentina',
    code: 'ar',
    phoneCode: '54',
    format: '(##) ########',
  },
  am: {
    name: 'Armenia',
    code: 'am',
    phoneCode: '374'
  },
  aw: {
    name: 'Aruba',
    code: 'aw',
    phoneCode: '297'
  },
  au: {
    name: 'Australia',
    code: 'au',
    phoneCode: '61',
    format: '(##) #### ####',
  },
  at: {
    name: 'Austria',
    code: 'at',
    phoneCode: '43'
  },
  az: {
    name: 'Azerbaijan',
    code: 'az',
    phoneCode: '994'
  },
  bs: {
    name: 'Bahamas',
    code: 'bs',
    phoneCode: '1242'
  },
  bh: {
    name: 'Bahrain',
    code: 'bh',
    phoneCode: '973'
  },
  bd: {
    name: 'Bangladesh',
    code: 'bd',
    phoneCode: '880'
  },
  bb: {
    name: 'Barbados',
    code: 'bb',
    phoneCode: '1246'
  },
  by: {
    name: 'Belarus',
    code: 'by',
    phoneCode: '375',
    format: '(##) ### ## ##',
  },
  be: {
    name: 'Belgium',
    code: 'be',
    phoneCode: '32',
    format: '### ## ## ##',
  },
  bz: {
    name: 'Belize',
    code: 'bz',
    phoneCode: '501'
  },
  bj: {
    name: 'Benin',
    code: 'bj',
    phoneCode: '229'
  },
  bt: {
    name: 'Bhutan',
    code: 'bt',
    phoneCode: '975'
  },
  bo: {
    name: 'Bolivia',
    code: 'bo',
    phoneCode: '591'
  },
  ba: {
    name: 'Bosnia and Herzegovina',
    code: 'ba',
    phoneCode: '387',
  },
  bw: {
    name: 'Botswana',
    code: 'bw',
    phoneCode: '267'
  },
  br: {
    name: 'Brazil',
    code: 'br',
    phoneCode: '55',
    format: '(##) #########',
  },
  io: {
    name: 'British Indian Ocean Territory',
    code: 'io',
    phoneCode: '246',
  },
  bn: {
    name: 'Brunei',
    code: 'bn',
    phoneCode: '673'
  },
  bg: {
    name: 'Bulgaria',
    code: 'bg',
    phoneCode: '359'
  },
  bf: {
    name: 'Burkina Faso',
    code: 'bf',
    phoneCode: '226'
  },
  bi: {
    name: 'Burundi',
    code: 'bi',
    phoneCode: '257'
  },
  kh: {
    name: 'Cambodia',
    code: 'kh',
    phoneCode: '855'
  },
  cm: {
    name: 'Cameroon',
    code: 'cm',
    phoneCode: '237'
  },
  ca: {
    name: 'Canada',
    code: 'ca',
    phoneCode: '1',
    format: '(###) ###-####',
    priority: 1,
    areaCodes: [
      '204',
      '226',
      '236',
      '249',
      '250',
      '289',
      '306',
      '343',
      '365',
      '387',
      '403',
      '416',
      '418',
      '431',
      '437',
      '438',
      '450',
      '506',
      '514',
      '519',
      '548',
      '579',
      '581',
      '587',
      '604',
      '613',
      '639',
      '647',
      '672',
      '705',
      '709',
      '742',
      '778',
      '780',
      '782',
      '807',
      '819',
      '825',
      '867',
      '873',
      '902',
      '905',
    ],
  },
  cv: {
    name: 'Cape Verde',
    code: 'cv',
    phoneCode: '238'
  },
  bq: {
    name: 'Caribbean Netherlands',
    code: 'bq',
    phoneCode: '599',
  },
  cf: {
    name: 'Central African Republic',
    code: 'cf',
    phoneCode: '236',
  },
  td: {
    name: 'Chad',
    code: 'td',
    phoneCode: '235'
  },
  cl: {
    name: 'Chile',
    code: 'cl',
    phoneCode: '56'
  },
  cn: {
    name: 'China',
    code: 'cn',
    phoneCode: '86',
    format: '##-#########',
  },
  co: {
    name: 'Colombia',
    code: 'co',
    phoneCode: '57'
  },
  km: {
    name: 'Comoros',
    code: 'km',
    phoneCode: '269'
  },
  cd: {
    name: 'Congo',
    code: 'cd',
    phoneCode: '243'
  },
  cg: {
    name: 'Congo',
    code: 'cg',
    phoneCode: '242'
  },
  cr: {
    name: 'Costa Rica',
    code: 'cr',
    phoneCode: '506',
    format: '####-####',
  },
  ci: {
    name: 'Côte d’Ivoire',
    code: 'ci',
    phoneCode: '225'
  },
  hr: {
    name: 'Croatia',
    code: 'hr',
    phoneCode: '385'
  },
  cu: {
    name: 'Cuba',
    code: 'cu',
    phoneCode: '53'
  },
  cw: {
    name: 'Curaçao',
    code: 'cw',
    phoneCode: '599',
    priority: 1,
  },
  cy: {
    name: 'Cyprus',
    code: 'cy',
    phoneCode: '357',
    format: '## ######',
  },
  cz: {
    name: 'Czech Republic',
    code: 'cz',
    phoneCode: '420'
  },
  dk: {
    name: 'Denmark',
    code: 'dk',
    phoneCode: '45',
    format: '## ## ## ##',
  },
  dj: {
    name: 'Djibouti',
    code: 'dj',
    phoneCode: '253'
  },
  dm: {
    name: 'Dominica',
    code: 'dm',
    phoneCode: '1767'
  },
  do: {
    name: 'Dominican Republic',
    code: 'do',
    phoneCode: '1',
    priority: 2,
    areaCodes: ['809', '829', '849'],
  },
  ec: {
    name: 'Ecuador',
    code: 'ec',
    phoneCode: '593'
  },
  eg: {
    name: 'Egypt',
    code: 'eg',
    phoneCode: '20'
  },
  sv: {
    name: 'El Salvador',
    code: 'sv',
    phoneCode: '503',
    format: '####-####',
  },
  gq: {
    name: 'Equatorial Guinea',
    code: 'gq',
    phoneCode: '240'
  },
  er: {
    name: 'Eritrea',
    code: 'er',
    phoneCode: '291'
  },
  ee: {
    name: 'Estonia',
    code: 'ee',
    phoneCode: '372',
    format: '#### ######',
  },
  et: {
    name: 'Ethiopia',
    code: 'et',
    phoneCode: '251'
  },
  fj: {
    name: 'Fiji',
    code: 'fj',
    phoneCode: '679'
  },
  fi: {
    name: 'Finland',
    code: 'fi',
    phoneCode: '358',
    format: '## ### ## ##',
  },
  fr: {
    name: 'France',
    code: 'fr',
    phoneCode: '33',
    format: '# ## ## ## ##',
  },
  gf: {
    name: 'French Guiana',
    code: 'gf',
    phoneCode: '594'
  },
  pf: {
    name: 'French Polynesia',
    code: 'pf',
    phoneCode: '689'
  },
  ga: {
    name: 'Gabon',
    code: 'ga',
    phoneCode: '241'
  },
  gm: {
    name: 'Gambia',
    code: 'gm',
    phoneCode: '220'
  },
  ge: {
    name: 'Georgia',
    code: 'ge',
    phoneCode: '995'
  },
  de: {
    name: 'Germany',
    code: 'de',
    phoneCode: '49',
    format: '#### ########',
  },
  gh: {
    name: 'Ghana',
    code: 'gh',
    phoneCode: '233'
  },
  gr: {
    name: 'Greece',
    code: 'gr',
    phoneCode: '30'
  },
  gd: {
    name: 'Grenada',
    code: 'gd',
    phoneCode: '1473'
  },
  gp: {
    name: 'Guadeloupe',
    code: 'gp',
    phoneCode: '590'
  },
  gu: {
    name: 'Guam',
    code: 'gu',
    phoneCode: '1671'
  },
  gt: {
    name: 'Guatemala',
    code: 'gt',
    phoneCode: '502',
    format: '####-####',
  },
  gn: {
    name: 'Guinea',
    code: 'gn',
    phoneCode: '224'
  },
  gw: {
    name: 'Guinea-Bissau',
    code: 'gw',
    phoneCode: '245'
  },
  gy: {
    name: 'Guyana',
    code: 'gy',
    phoneCode: '592'
  },
  ht: {
    name: 'Haiti',
    code: 'ht',
    phoneCode: '509',
    format: '####-####',
  },
  hn: {
    name: 'Honduras',
    code: 'hn',
    phoneCode: '504'
  },
  hk: {
    name: 'Hong Kong',
    code: 'hk',
    phoneCode: '852',
    format: '#### ####',
  },
  hu: {
    name: 'Hungary',
    code: 'hu',
    phoneCode: '36'
  },
  is: {
    name: 'Iceland',
    code: 'is',
    phoneCode: '354',
    format: '### ####',
  },
  in: {
    name: 'India',
    code: 'in',
    phoneCode: '91',
    format: '#####-#####',
  },
  id: {
    name: 'Indonesia',
    code: 'id',
    phoneCode: '62'
  },
  ir: {
    name: 'Iran',
    code: 'ir',
    phoneCode: '98',
    format: '### ### ####',
  },
  iq: {
    name: 'Iraq',
    code: 'iq',
    phoneCode: '964'
  },
  ie: {
    name: 'Ireland',
    code: 'ie',
    phoneCode: '353',
    format: '## #######',
  },
  il: {
    name: 'Israel',
    code: 'il',
    phoneCode: '972',
    format: '### ### ####',
  },
  it: {
    name: 'Italy',
    code: 'it',
    phoneCode: '39',
    format: '### #######',
  },
  jm: {
    name: 'Jamaica',
    code: 'jm',
    phoneCode: '1876'
  },
  jp: {
    name: 'Japan',
    code: 'jp',
    phoneCode: '81',
    format: '## #### ####',
  },
  jo: {
    name: 'Jordan',
    code: 'jo',
    phoneCode: '962'
  },
  kz: {
    name: 'Kazakhstan',
    code: 'kz',
    phoneCode: '7',
    format: '### ###-##-##',
    priority: 1,
    areaCodes: ['310', '311', '312', '313', '315', '318', '321', '324', '325', '326', '327', '336', '7172', '73622'],
  },
  ke: {
    name: 'Kenya',
    code: 'ke',
    phoneCode: '254'
  },
  ki: {
    name: 'Kiribati',
    code: 'ki',
    phoneCode: '686'
  },
  xk: {
    name: 'Kosovo',
    code: 'xk',
    phoneCode: '383'
  },
  kw: {
    name: 'Kuwait',
    code: 'kw',
    phoneCode: '965'
  },
  kg: {
    name: 'Kyrgyzstan',
    code: 'kg',
    phoneCode: '996'
  },
  la: {
    name: 'Laos',
    code: 'la',
    phoneCode: '856'
  },
  lv: {
    name: 'Latvia',
    code: 'lv',
    phoneCode: '371'
  },
  lb: {
    name: 'Lebanon',
    code: 'lb',
    phoneCode: '961'
  },
  ls: {
    name: 'Lesotho',
    code: 'ls',
    phoneCode: '266'
  },
  lr: {
    name: 'Liberia',
    code: 'lr',
    phoneCode: '231'
  },
  ly: {
    name: 'Libya',
    code: 'ly',
    phoneCode: '218'
  },
  li: {
    name: 'Liechtenstein',
    code: 'li',
    phoneCode: '423'
  },
  lt: {
    name: 'Lithuania',
    code: 'lt',
    phoneCode: '370'
  },
  lu: {
    name: 'Luxembourg',
    code: 'lu',
    phoneCode: '352'
  },
  mo: {
    name: 'Macau',
    code: 'mo',
    phoneCode: '853'
  },
  mk: {
    name: 'Macedonia',
    code: 'mk',
    phoneCode: '389'
  },
  mg: {
    name: 'Madagascar',
    code: 'mg',
    phoneCode: '261'
  },
  mw: {
    name: 'Malawi',
    code: 'mw',
    phoneCode: '265'
  },
  my: {
    name: 'Malaysia',
    code: 'my',
    phoneCode: '60',
    format: '##-####-####',
  },
  mv: {
    name: 'Maldives',
    code: 'mv',
    phoneCode: '960'
  },
  ml: {
    name: 'Mali',
    code: 'ml',
    phoneCode: '223'
  },
  mt: {
    name: 'Malta',
    code: 'mt',
    phoneCode: '356'
  },
  mh: {
    name: 'Marshall Islands',
    code: 'mh',
    phoneCode: '692'
  },
  mq: {
    name: 'Martinique',
    code: 'mq',
    phoneCode: '596'
  },
  mr: {
    name: 'Mauritania',
    code: 'mr',
    phoneCode: '222'
  },
  mu: {
    name: 'Mauritius',
    code: 'mu',
    phoneCode: '230'
  },
  mx: {
    name: 'Mexico',
    code: 'mx',
    phoneCode: '52',
    format: '### ### ####',
    priority: 0,
    areaCodes: ['55', '81', '33', '656', '664', '998', '774', '229'],
  },
  fm: {
    name: 'Micronesia',
    code: 'fm',
    phoneCode: '691'
  },
  md: {
    name: 'Moldova',
    code: 'md',
    phoneCode: '373',
    format: '(##) ##-##-##',
  },
  mc: {
    name: 'Monaco',
    code: 'mc',
    phoneCode: '377'
  },
  mn: {
    name: 'Mongolia',
    code: 'mn',
    phoneCode: '976'
  },
  me: {
    name: 'Montenegro',
    code: 'me',
    phoneCode: '382'
  },
  ma: {
    name: 'Morocco',
    code: 'ma',
    phoneCode: '212'
  },
  mz: {
    name: 'Mozambique',
    code: 'mz',
    phoneCode: '258'
  },
  mm: {
    name: 'Myanmar',
    code: 'mm',
    phoneCode: '95'
  },
  na: {
    name: 'Namibia',
    code: 'na',
    phoneCode: '264'
  },
  nr: {
    name: 'Nauru',
    code: 'nr',
    phoneCode: '674'
  },
  np: {
    name: 'Nepal',
    code: 'np',
    phoneCode: '977'
  },
  nl: {
    name: 'Netherlands',
    code: 'nl',
    phoneCode: '31',
    format: '## ########',
  },
  nc: {
    name: 'New Caledonia',
    code: 'nc',
    phoneCode: '687'
  },
  nz: {
    name: 'New Zealand',
    code: 'nz',
    phoneCode: '64',
    format: '###-###-####',
  },
  ni: {
    name: 'Nicaragua',
    code: 'ni',
    phoneCode: '505'
  },
  ne: {
    name: 'Niger',
    code: 'ne',
    phoneCode: '227'
  },
  ng: {
    name: 'Nigeria',
    code: 'ng',
    phoneCode: '234'
  },
  kp: {
    name: 'North Korea',
    code: 'kp',
    phoneCode: '850'
  },
  no: {
    name: 'Norway',
    code: 'no',
    phoneCode: '47',
    format: '### ## ###',
  },
  om: {
    name: 'Oman',
    code: 'om',
    phoneCode: '968'
  },
  pk: {
    name: 'Pakistan',
    code: 'pk',
    phoneCode: '92',
    format: '###-#######',
  },
  pw: {
    name: 'Palau',
    code: 'pw',
    phoneCode: '680'
  },
  ps: {
    name: 'Palestine',
    code: 'ps',
    phoneCode: '970'
  },
  pa: {
    name: 'Panama',
    code: 'pa',
    phoneCode: '507'
  },
  pg: {
    name: 'Papua New Guinea',
    code: 'pg',
    phoneCode: '675'
  },
  py: {
    name: 'Paraguay',
    code: 'py',
    phoneCode: '595'
  },
  pe: {
    name: 'Peru',
    code: 'pe',
    phoneCode: '51'
  },
  ph: {
    name: 'Philippines',
    code: 'ph',
    phoneCode: '63',
    format: '#### #######',
  },
  pl: {
    name: 'Poland',
    code: 'pl',
    phoneCode: '48',
    format: '###-###-###',
  },
  pt: {
    name: 'Portugal',
    code: 'pt',
    phoneCode: '351'
  },
  pr: {
    name: 'Puerto Rico',
    code: 'pr',
    phoneCode: '1',
    priority: 3,
    areaCodes: ['787', '939'],
  },
  qa: {
    name: 'Qatar',
    code: 'qa',
    phoneCode: '974'
  },
  re: {
    name: 'Réunion',
    code: 're',
    phoneCode: '262'
  },
  ro: {
    name: 'Romania',
    code: 'ro',
    phoneCode: '40'
  },
  ru: {
    name: 'Russia',
    code: 'ru',
    phoneCode: '7',
    format: '(###) ###-##-##',
  },
  rw: {
    name: 'Rwanda',
    code: 'rw',
    phoneCode: '250'
  },
  kn: {
    name: 'Saint Kitts and Nevis',
    code: 'kn',
    phoneCode: '1869',
  },
  lc: {
    name: 'Saint Lucia',
    code: 'lc',
    phoneCode: '1758'
  },
  vc: {
    name: 'Saint Vincent and the Grenadines',
    code: 'vc',
    phoneCode: '1784',
  },
  ws: {
    name: 'Samoa',
    code: 'ws',
    phoneCode: '685'
  },
  sm: {
    name: 'San Marino',
    code: 'sm',
    phoneCode: '378'
  },
  st: {
    name: 'São Tomé and Príncipe',
    code: 'st',
    phoneCode: '239',
  },
  sa: {
    name: 'Saudi Arabia',
    code: 'sa',
    phoneCode: '966'
  },
  sn: {
    name: 'Senegal',
    code: 'sn',
    phoneCode: '221'
  },
  rs: {
    name: 'Serbia',
    code: 'rs',
    phoneCode: '381'
  },
  sc: {
    name: 'Seychelles',
    code: 'sc',
    phoneCode: '248'
  },
  sl: {
    name: 'Sierra Leone',
    code: 'sl',
    phoneCode: '232'
  },
  sg: {
    name: 'Singapore',
    code: 'sg',
    phoneCode: '65',
    format: '####-####',
  },
  sk: {
    name: 'Slovakia',
    code: 'sk',
    phoneCode: '421'
  },
  si: {
    name: 'Slovenia',
    code: 'si',
    phoneCode: '386'
  },
  sb: {
    name: 'Solomon Islands',
    code: 'sb',
    phoneCode: '677'
  },
  so: {
    name: 'Somalia',
    code: 'so',
    phoneCode: '252'
  },
  za: {
    name: 'South Africa',
    code: 'za',
    phoneCode: '27'
  },
  kr: {
    name: 'South Korea',
    code: 'kr',
    phoneCode: '82',
    format: '### #### ####',
  },
  ss: {
    name: 'South Sudan',
    code: 'ss',
    phoneCode: '211'
  },
  es: {
    name: 'Spain',
    code: 'es',
    phoneCode: '34',
    format: '### ### ###',
  },
  lk: {
    name: 'Sri Lanka',
    code: 'lk',
    phoneCode: '94'
  },
  sd: {
    name: 'Sudan',
    code: 'sd',
    phoneCode: '249'
  },
  sr: {
    name: 'Suriname',
    code: 'sr',
    phoneCode: '597'
  },
  sz: {
    name: 'Swaziland',
    code: 'sz',
    phoneCode: '268'
  },
  se: {
    name: 'Sweden',
    code: 'se',
    phoneCode: '46',
    format: '(###) ###-###',
  },
  ch: {
    name: 'Switzerland',
    code: 'ch',
    phoneCode: '41',
    format: '## ### ## ##',
  },
  sy: {
    name: 'Syria',
    code: 'sy',
    phoneCode: '963'
  },
  tw: {
    name: 'Taiwan',
    code: 'tw',
    phoneCode: '886'
  },
  tj: {
    name: 'Tajikistan',
    code: 'tj',
    phoneCode: '992'
  },
  tz: {
    name: 'Tanzania',
    code: 'tz',
    phoneCode: '255'
  },
  th: {
    name: 'Thailand',
    code: 'th',
    phoneCode: '66'
  },
  tl: {
    name: 'Timor-Leste',
    code: 'tl',
    phoneCode: '670'
  },
  tg: {
    name: 'Togo',
    code: 'tg',
    phoneCode: '228'
  },
  to: {
    name: 'Tonga',
    code: 'to',
    phoneCode: '676'
  },
  tt: {
    name: 'Trinidad and Tobago',
    code: 'tt',
    phoneCode: '1868',
  },
  tn: {
    name: 'Tunisia',
    code: 'tn',
    phoneCode: '216'
  },
  tr: {
    name: 'Turkey',
    code: 'tr',
    phoneCode: '90',
    format: '### ### ## ##',
  },
  tm: {
    name: 'Turkmenistan',
    code: 'tm',
    phoneCode: '993'
  },
  tv: {
    name: 'Tuvalu',
    code: 'tv',
    phoneCode: '688'
  },
  ug: {
    name: 'Uganda',
    code: 'ug',
    phoneCode: '256'
  },
  ua: {
    name: 'Ukraine',
    code: 'ua',
    phoneCode: '380',
    format: '(##) ### ## ##',
  },
  ae: {
    name: 'United Arab Emirates',
    code: 'ae',
    phoneCode: '971',
  },
  gb: {
    name: 'United Kingdom',
    code: 'gb',
    phoneCode: '44',
    format: '#### ######',
  },
  us: {
    name: 'United States',
    code: 'us',
    phoneCode: '1',
    priority: 0,
    format: '### - ### - ####',
    areaCodes: [
      '907',
      '205',
      '251',
      '256',
      '334',
      '479',
      '501',
      '870',
      '480',
      '520',
      '602',
      '623',
      '928',
      '209',
      '213',
      '310',
      '323',
      '408',
      '415',
      '510',
      '530',
      '559',
      '562',
      '619',
      '626',
      '650',
      '661',
      '707',
      '714',
      '760',
      '805',
      '818',
      '831',
      '858',
      '909',
      '916',
      '925',
      '949',
      '951',
      '303',
      '719',
      '970',
      '203',
      '860',
      '202',
      '302',
      '239',
      '305',
      '321',
      '352',
      '386',
      '407',
      '561',
      '727',
      '772',
      '813',
      '850',
      '863',
      '904',
      '941',
      '954',
      '229',
      '404',
      '478',
      '706',
      '770',
      '912',
      '808',
      '319',
      '515',
      '563',
      '641',
      '712',
      '208',
      '217',
      '309',
      '312',
      '618',
      '630',
      '708',
      '773',
      '815',
      '847',
      '219',
      '260',
      '317',
      '574',
      '765',
      '812',
      '316',
      '620',
      '785',
      '913',
      '270',
      '502',
      '606',
      '859',
      '225',
      '318',
      '337',
      '504',
      '985',
      '413',
      '508',
      '617',
      '781',
      '978',
      '301',
      '410',
      '207',
      '231',
      '248',
      '269',
      '313',
      '517',
      '586',
      '616',
      '734',
      '810',
      '906',
      '989',
      '218',
      '320',
      '507',
      '612',
      '651',
      '763',
      '952',
      '314',
      '417',
      '573',
      '636',
      '660',
      '816',
      '228',
      '601',
      '662',
      '406',
      '252',
      '336',
      '704',
      '828',
      '910',
      '919',
      '701',
      '308',
      '402',
      '603',
      '201',
      '609',
      '732',
      '856',
      '908',
      '973',
      '505',
      '575',
      '702',
      '775',
      '212',
      '315',
      '516',
      '518',
      '585',
      '607',
      '631',
      '716',
      '718',
      '845',
      '914',
      '216',
      '330',
      '419',
      '440',
      '513',
      '614',
      '740',
      '937',
      '405',
      '580',
      '918',
      '503',
      '541',
      '215',
      '412',
      '570',
      '610',
      '717',
      '724',
      '814',
      '401',
      '803',
      '843',
      '864',
      '605',
      '423',
      '615',
      '731',
      '865',
      '901',
      '931',
      '210',
      '214',
      '254',
      '281',
      '325',
      '361',
      '409',
      '432',
      '512',
      '713',
      '806',
      '817',
      '830',
      '903',
      '915',
      '936',
      '940',
      '956',
      '972',
      '979',
      '435',
      '801',
      '276',
      '434',
      '540',
      '703',
      '757',
      '804',
      '802',
      '206',
      '253',
      '360',
      '425',
      '509',
      '262',
      '414',
      '608',
      '715',
      '920',
      '304',
      '307',
    ],
  },
  uy: {
    name: 'Uruguay',
    code: 'uy',
    phoneCode: '598'
  },
  uz: {
    name: 'Uzbekistan',
    code: 'uz',
    phoneCode: '998'
  },
  vu: {
    name: 'Vanuatu',
    code: 'vu',
    phoneCode: '678'
  },
  va: {
    name: 'Vatican City',
    code: 'va',
    phoneCode: '39',
    format: '## #### ####',
    priority: 1,
  },
  ve: {
    name: 'Venezuela',
    code: 've',
    phoneCode: '58'
  },
  vn: {
    name: 'Vietnam',
    code: 'vn',
    phoneCode: '84'
  },
  ye: {
    name: 'Yemen',
    code: 'ye',
    phoneCode: '967'
  },
  zm: {
    name: 'Zambia',
    code: 'zm',
    phoneCode: '260'
  },
  zw: {
    name: 'Zimbabwe',
    code: 'zw',
    phoneCode: '263'
  },
};

// Convert Object values to Array
const COUNTRIES_ARRAY = Object.values(COUNTRIES_OBJ);

// Create a new array with the necessary data
const PhoneCodeValue = COUNTRIES_ARRAY.map(country => ({
  value: country.code.toUpperCase(),
  label: `${country.code.toUpperCase()} +${country.phoneCode}`,
  code: country.phoneCode,
}));

// Set USA as default country
let defaultCountry = PhoneCodeValue.find(item => item.value == 'US')

async function retrieveCountryByIp(select) {
  const response = await fetch('https://ipinfo.io/json');
  const { country } = (await response.json());

  if (!country) return

  defaultCountry = PhoneCodeValue.find(option => option.value === country);
  select.setValue(defaultCountry.value)
  return false
}



/**
 * VARIABLES
 */

// Form State variables
let canSend = true,
  isSubmitted = false

/**
 * METHODS
 */



/**
 * Render custom select with international phone codes data
 * 
 * @param {string} selector 
 * @param {Array} data 
 * @returns void
 */
const renderCustomSelect = (selector, data) => {
  if (!selector) return false;
  // Custom select for international phone code
  const select = new TomSelect(selector, {
    create: false,
    maxItems: 1,
    maxOptions: 220,
    valueField: 'value',
    labelField: 'label',
    searchField: 'label',
    sortField: 'label',
    items: [defaultCountry.value],
    placeholder: `${defaultCountry.value} +${defaultCountry.code}`,
    hidePlaceholder: false,
    options: data,
    onItemAdd: function (value, item) {
      this.input.value = item.dataset.code
      this.settings.placeholder = `${item.dataset.value} +${item.dataset.code}`
    },
    render: {
      option: function (data, escape) {
        return `<div title="${escape(data.code)}">
          <span class="value">${escape(data.value)}</span>
          <span class="code">+${escape(data.code)}</span>
        </div>`
      },
      item: function (data, escape) {
        return `<div data-code="${escape(data.code)}">${escape(data.label)}</div>`;
      },
    },

  })

  retrieveCountryByIp(select)
}

/**
 * Convert seconds to string
 * 
 * @param {number} sec 
 * @returns {string}
 */
const secToString = (sec) => {
  if (sec < 10) {
    return `0:0${sec}`;
  } else {
    return `0:${sec}`;
  }
};

/**
 * Validate user phone
 * 
 * @param {string} phone 
 * @param {string} code 
 * @returns {(string|boolean)} 
 */
const phoneValidator = (phone, code = 'US') => {
  if (undefined !== validatePhoneNumberLength(phone, code)) return false
  // Parse phone number metadata
  const phoneNumber = parsePhoneNumber(phone)

  let isValid = (
    code === phoneNumber.country &&
    isPossiblePhoneNumber(phone, code) &&
    true === isValidPhoneNumber(phone, code)
  )

  if (!isValid) return false
  // Return valid phone number
  return phoneNumber.number
}

/**
 * Show thank you message
 * 
 * @param {Object} form 
 * @param string message 
 * @returns void
 */
const thankYouMessage = (form = '', message) => {
  let smsMessage = document.getElementById(message)
  if (!isSubmitted && !message) return false
  if (form) form.classList.add('hide')

  smsMessage.classList.toggle('show')
}

/**
 * Timer to prevent sending the form several times in a row
 * 
 * @param {Object} element 
 * @returns {string}
 */
const antiSpamTimer = (element) => {
  const waitTimeTillNext = 60 * 1000,
    timeTillEndRef = {'current': 0},
    intervalHolder = {'current': 0};

  currentValue = element.value;

  let setWaitTimeStr = '';

  (() => {
    // Get localstorage data
    const lastSubmitTime = localStorage.getItem(LS_KEY);
    if (!lastSubmitTime) return;
    // Remember curent time
    const currenTime = new Date().getTime();
    // Passed Time
    const timePassed = currenTime - +lastSubmitTime;

    // 
    if (timePassed < waitTimeTillNext) {

      timeTillEndRef.current = Math.ceil(
        (waitTimeTillNext - timePassed) / 1000
      );

      setWaitTimeStr = secToString(timeTillEndRef.current);

      // Set initial values
      element.value = setWaitTimeStr
      element.disabled = true
      thankYouMessage('', 'sdc_sms_wait')

      // Run timer
      intervalHolder.current = window.setInterval(() => {
        timeTillEndRef.current -= 1;

        if (timeTillEndRef.current === 0) {

          setWaitTimeStr = undefined;
          clearInterval(intervalHolder.current);
          // Clear local storage
          localStorage.removeItem(LS_KEY);

          // Set default values
          element.value = currentValue
          element.disabled = false
          thankYouMessage('', 'sdc_sms_wait')
        } else {
          // Update values
          setWaitTimeStr = secToString(timeTillEndRef.current);
          element.value = setWaitTimeStr
        }
      }, 1000);
    } else {
      localStorage.removeItem(LS_KEY);
    }
    return () => {
      if (intervalHolder.current) {
        clearInterval(intervalHolder.current);
      }
    };
  })(timeTillEndRef, intervalHolder)
  return setWaitTimeStr;
}

/**
 * Send form data
 * 
 * @param {Object} form 
 * @param {Object} params
 * @returns {Promise}
 */
const sendData = (form, params) => {
  fetch('https://api-teams.core.usw2.surprise.com/api/v1/download_app_link', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
      referrer: 'no-referrer',
      body: JSON.stringify(params),
    })
    .then(response => {
      form.elements.user_tel_number.value = ''
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      // Remember the time of sending the form
      const submitTime = new Date().getTime();
      localStorage.setItem(LS_KEY, '' + submitTime);
      form.reset()
      form.remove()
      thankYouMessage(form, 'sdc_sms_message')
      return response.json()
    })
    .catch(error => {
      console.error(error);
      form.elements.user_tel_number.value = ''
      return false
    });
}

/**
 * SMS Form Handler
 * 
 * @param {Object} form 
 * @returns void
 */
const SMSFormHandler = (form) => {
  if (!form) return false;
  let inpCode = form.elements.user_tel_code,
    inpNumber = form.elements.user_tel_number,
    elements = [inpCode, inpNumber],
    validPhone = false

  elements.map(element => {
    element.addEventListener('input', () => {
      // Selected country phone code
      let phoneCode = PhoneCodeValue.find(item => item.value == inpCode.value).code

      // Obtained data entered by the user
      validPhone = phoneValidator(`+${phoneCode + inpNumber.value}`, inpCode.value)
    })
  })

  // Remove error class after start typing
  form.addEventListener('keydown', () => {
    inpNumber.classList.remove('error')
  })

  // Submit Form
  form.addEventListener('submit', (event) => {
    event.preventDefault();

    // Check if entered number is valid
    if (!validPhone) {
      inpNumber.classList.add('error')
      return false
    }
    param = {
      phone_number: validPhone,
    }
    // Send form
    sendData(form, param)
    // testData(form, param)
    validPhone = ''
  });

}

document.addEventListener('DOMContentLoaded', () => {
  // Call custom select
  renderCustomSelect('#user_tel_code', PhoneCodeValue)
  SMSFormHandler(document.forms.sdc_sms_form)
  antiSpamTimer(document.forms.sdc_sms_form.submit)
})
